import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex)
 
export const store = new Vuex.Store({
  state: {
    forgotPassword : null,
    changePassword : null
  },
  mutations: {
    FORGOT_PASSWORD: (state,  forgotPassword ) => {
      state.forgotPassword = forgotPassword;
    },
    CHANGE_PASSWORD: (state,  changePassword ) => {
      state.changePassword = changePassword;
    }
  },
  getters: {
    forgotPassword: (state ) => {
      return state.forgotPassword;
    },
    changePassword: (state ) => {
      return state.changePassword;
    },
    
  }
})